export type CguModalMode = "welcome" | "update" | null;

export function getCguModalMode(
  cgu: number | undefined,
  isModeration: boolean,
  requiredVersion: number
): CguModalMode {
  if (isModeration) {
    return null;
  }
  if (cgu == null) {
    return "welcome";
  }
  if (cgu < requiredVersion) {
    return "update";
  }
  return null;
}
